/**
 * Check-in class component
 */
/*import AlteaCheckIn from '../booking/quick-booking-panel/components/check-in/DeepLinks/AlteaCheckIn'
import SabreCheckIn from '../booking/quick-booking-panel/components/check-in/DeepLinks/SabreCheckIn'
import IPortCheckIn from '../booking/quick-booking-panel/components/check-in/DeepLinks/IPortCheckIn'
*/

import axios from 'axios'
import TextInput from '../../components/fields/TextInput'
import { createUrlParamsFromObject } from 'ContentBundle/js/frontend/utils/qS'

class FindBookingDetails {
    constructor(domElement = null) {
        this.container = $(domElement)

        if(!this.container.length) {
            console.error('Please provide proper DOM element for Check-in Class')
            return
        }

        // Fetch data
        const { index } = this.container.data()
        const { routes } = window[`booking_details_${index}_data`]

        this.routes = routes
        this.instances = {}

        this.init()
        this.setEventListeners()
    }

    /**
     * Destroy method
     */
    destroy() {
        this.removeEventListeners()
    }

    /**
     * Attach event listeners
     */
    setEventListeners() {
        this.container.on('click', '.btn-submit', this.handleSubmit.bind(this))
    }

    /**
     * Remove event listeners
     */
    removeEventListeners() {
        this.container.off('click')
    }

    /**
     * Fields initialization
     */
    init() {
        const textInputs = this.container.find('input.form-input')
        textInputs.each((_, input) => {
            const { name } = $(input).data()
            const inputInstance = new TextInput(input, {
                popoverValidation: true
            })

            this.instances[name] = inputInstance
        })
    }

    /**
     * Handle form submission
     * @param {Object} event
     */
    handleSubmit(event) {
        event.stopPropagation()

        let isValid = true
        const payload = {}

        // @Todo validate booking code/ticket number values
        // https://gist.github.com/eightyknots/4372d1166a192d5e9754

        Object.keys(this.instances).forEach(inputName => {
            // Validate
            const inputInstance = this.instances[inputName]
            if(!inputInstance.validate()) {
                isValid = false
            }

            // Get value
            const value = inputInstance.getValue().trim()
            payload[inputName] = value
        })

        if (isValid) {
            this.handleCheckIn(payload)
        }
    }

    /**
     * Check in handler
     * @param {Object} payload
     */
    async handleCheckIn(payload = {}) {
        const $submitBtn = this.container.find('.btn-submit')
        const querries = createUrlParamsFromObject(payload)

        this.clearErrorMessage()
        $submitBtn.addClass('is-requesting')

        try {
            const route = `${this.routes.api}?${querries}`
            const response = await axios.get(route)

            if (response && response.data) {
                // Redirect to form document
                const { bookingReference, surname } = response.data

                const redirectRoute = `${this.routes.formRedirect}?booking_reference=${bookingReference}&surname=${surname}`
                window.location.href = redirectRoute
            }
        } catch (error) {
            $submitBtn.removeClass('is-requesting')

            if (error && error.response && error.response.data) {
                this.handleErrorResponse(error.response.data)
            }

            console.error(error)
            throw error
        }
    }

    handleErrorResponse(errResponse = {}) {
        const { title, status, detail, msg } = errResponse
        const errorMsgWrapper = this.container.find('.error-msg-wrapper')

        let errorMarkup

        if (title && detail) {
            errorMarkup = `
                <div class="alert alert-danger mb-5" role="alert">
                    <h5 class="alert-heading mb-1">
                        ${title} with status: ${status}
                    </h5>
                    <p class="small">
                        ${detail ? detail.replace(/\n/g, "<br />") : ''}
                    </p>
                </div>
            `
        } else if (msg) {
            errorMarkup = `
                <div class="alert alert-danger mb-5" role="alert">
                    <p class="small">
                        ${msg}
                    </p>
                </div>
            `
        } else {
            errorMarkup = `
                <div class="alert alert-danger mb-5" role="alert">
                    <h5 class="alert-heading mb-1">
                        Internal server error
                    </h5>
                    <p class="small">
                        The server encountered an internal error or misconfiguration and was unable to complete your request.
                    </p>
                </div>
            `
        }

        errorMsgWrapper.html(errorMarkup)
    }

    clearErrorMessage() {
        const errorMsgWrapper = this.container.find('.error-msg-wrapper')
        errorMsgWrapper.html('')
    }
}

export default FindBookingDetails
